import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import imgUrl from "../../assets/images/imageUrl";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import BadgeIcon from "@mui/icons-material/Badge";
import WcIcon from "@mui/icons-material/Wc";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ChurchIcon from "@mui/icons-material/Church";
import PushPinIcon from "@mui/icons-material/PushPin";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import LayersIcon from '@mui/icons-material/Layers';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import { withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import PatientTabs from "./PatientTabs";
import MyMapComponent from "./MyMapComponent";
import Gauge from "./Gauge";
import axios from 'axios';
import { apiServices } from "../../services/apiServices";
import moment from "moment";


function PatientDashboard(userData) {
  const [patientsData, setPatientsData] = useState({});
  useEffect(() => {

    let oRequest = {
      "param1":userData.userData.programOwners[0].program,
      "param2":userData.userData.orgUnit, 
      "param3":userData.userData.trackedEntityInstance
  }
  apiServices.postAPI('dashboardIndicator/getPatientData/get_custom_dashboard_registration', oRequest)
  .then((res) => {
      setPatientsData(res.data.data[0])
  })
  .catch((error) => {
    console.log("error",error)
  })
  }, []);


  return (
    <div className="patientDashboardSection">
      <Grid container className="mt-57px">
        <Grid item xs={4} md={3} className="bg-blue">
          <div>
            <div className="profile-card mt-30px">
              {/* <AccountCircleIcon className="profile-icon"></AccountCircleIcon> */}
              <img src={imgUrl.profile_user}></img>
              <h4 className="mt-5px mb-0 profile-head">{patientsData.Name} ({patientsData.Gender}),{patientsData.DOB ? moment().diff(`${patientsData.DOB}`, 'years') : ""}</h4>
              <p className="mt-5px mb-0">Last visit: {moment(userData.userData.lastUpdatedAtClient).format("DD/MM/YYYY")}</p>
            </div>
            <div className="profile-social mt-20px">
              <img src={imgUrl.phone_icon}></img>
              <div className="border-right"></div>
              <img src={imgUrl.location_icon}></img>
              <div className="border-right"></div>
              <img src={imgUrl.msg_icon}></img>
              <div className="border-right"></div>
              <img src={imgUrl.scanprofile_icon}></img>
            </div>
            <div className="profile-stats">
              {/* <img src={imgUrl.profile_stats} className="w-50"></img> */}
              <Gauge/>
             
            </div>
            <div className="profile-summary">
              <Accordion defaultExpanded className="mb-0 second-accordion">
                <AccordionSummary
                  expandIcon={<KeyboardDoubleArrowUpIcon className="acc-svg" />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  DEMOGRAPHICS AND CONTACT DETAILS
                </AccordionSummary>
                <AccordionDetails>
                  <div>
                    <div className="mb-10px">
                      <div className="profile-badge">
                        <BadgeIcon></BadgeIcon>{" "}
                        <p className="mt-15px mx-4px">NAME: {patientsData.Name}</p>
                      </div>
                      <div className="profile-badge">
                        <WcIcon></WcIcon>{" "}
                        <p className="mt-15px mx-4px">GENDER: {patientsData.Gender}</p>
                      </div>
                      <div className="profile-badge">
                        <CalendarMonthIcon></CalendarMonthIcon>{" "}
                        <p className="mt-15px mx-4px">DOB: {patientsData.DOB}</p>
                      </div>
                      <div className="profile-badge">
                        <CalendarMonthIcon></CalendarMonthIcon>{" "}
                        <p className="mt-15px mx-4px">AGE: {patientsData.DOB ? moment().diff(`${patientsData.DOB}`, 'years') : ""}</p>
                      </div>
                      <div className="profile-badge">
                        <PushPinIcon></PushPinIcon>{" "}
                        <p className="mt-15px mx-4px">REGION: {patientsData.Region}</p>
                      </div>
                      <div className="profile-badge">
                        <LocationOnIcon></LocationOnIcon>{" "}
                        <p className="mt-15px mx-4px">ADDRESS: {patientsData.Address}</p>
                      </div>
                      <div className="profile-badge">
                        <PhoneInTalkIcon></PhoneInTalkIcon>{" "}
                        <p className="mt-15px mx-4px">
                          PATIENT CONTACT: {patientsData.Patient_Contact}
                        </p>
                      </div>
                      <div className="profile-badge">
                        <PhoneInTalkIcon></PhoneInTalkIcon>{" "}
                        <p className="mt-15px mx-4px">
                          GUARDIAN CONTACT.: {patientsData.Guardian_contact}
                        </p>
                      </div>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
              <Accordion defaultExpanded className="mt-0 mb-0 second-accordion">
                <AccordionSummary
                  expandIcon={<KeyboardDoubleArrowUpIcon className="acc-svg" />}
                  aria-controls="panel2-content"
                  id="panel2-header"
                >
                  SOCIO ECONOMIC DETAILS
                </AccordionSummary>
                <AccordionDetails>
                <div className="mb-10px">
                      <div className="profile-badge">
                        <CalendarMonthIcon></CalendarMonthIcon>{" "}
                        <p className="mt-15px mx-4px">DATE OF ENROLLMENT:{patientsData.Date_enrollment}</p>
                      </div>
                      <div className="profile-badge">
                        <ChurchIcon></ChurchIcon>{" "}
                        <p className="mt-15px mx-4px">RELIGION: {patientsData.Religion}</p>
                      </div>
                      <div className="profile-badge">
                        <BadgeIcon></BadgeIcon>{" "}
                        <p className="mt-15px mx-4px">NATIONAL ID NO:{patientsData.National_ID}</p>
                      </div>
                      <div className="profile-badge">
                        <AttachMoneyIcon></AttachMoneyIcon>{" "}
                        <p className="mt-15px mx-4px">INSURANCE STATUS: {patientsData.Insurance_status}</p>
                      </div>
                      <div className="profile-badge">
                        <LayersIcon></LayersIcon>{" "}
                        <p className="mt-15px mx-4px">PATIENT EDUCATION: {patientsData.Patient_Education}</p>
                      </div>
                      <div className="profile-badge">
                      <AttachMoneyIcon></AttachMoneyIcon>
                        <p className="mt-15px mx-4px">HOUSEHOLD INCOME: {patientsData.Household_Income}</p>
                      </div>
                      <div className="profile-badge">
                        <MonitorHeartIcon></MonitorHeartIcon>{" "}
                        <p className="mt-15px mx-4px">PARENT MORTALITY: {patientsData.Parent_Mortality}</p>
                      </div>
                     
                    </div>
                </AccordionDetails>
              </Accordion>
              <Accordion defaultExpanded className="mt-0 mb-0 second-accordion">
                <AccordionSummary
                  expandIcon={<KeyboardDoubleArrowUpIcon className="acc-svg" />}
                  aria-controls="panel3-content"
                  id="panel3-header"
                >
                  LOCATION
                </AccordionSummary>
                <AccordionDetails>
                   <div className="location-section">
                   <div className="">
                      <div className="profile-badge mb-0">
                        <LocationOnIcon></LocationOnIcon>{" "}
                        <p className="mt-15px mx-4px">{patientsData.Address}</p>
                      </div>
                      <div>
                        <MyMapComponent location={patientsData.Address_Location}/>
                        </div>

                      {/* <MyMapComponent isMarkerShown />
                      <MyMapComponent isMarkerShown={false} /> */}
                      <div className="profile-badge pb-15px">
                        <img src={imgUrl.maplocate_icon} className="w-10"></img>
                        <p className="mt-15px mx-4px">Distance from facility : <span> 75 kms </span> </p>
                      </div>
                     
                     
                    </div>
                   </div>
                </AccordionDetails>
              </Accordion>
            </div>
           
          </div>
        </Grid>
        <Grid item xs={8} md={9}>
          <div>
             
             <PatientTabs userData={userData}/> 
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default PatientDashboard;
